var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Builder',{attrs:{"blocks":_vm.blocks,"context":_vm.context}})
}
var staticRenderFns = []

export { render, staticRenderFns }